import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrVU: CultureInfo = {
  name: 'fr-VU',
  displayName: 'français (Vanuatu)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-VU',
  parent: CultureInfoFr
};
